// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Hleb Serafimovich <hleb.serafimovich@celadon.ae>

const ARRANGE_COLLECTION_REQUEST = 'ARRANGE_COLLECTION_REQUEST';
const ARRANGE_COLLECTION_SET_STATUS = 'ARRANGE_COLLECTION_SET_STATUS';

const ARRANGE_COLLECTION_START_LOADER = 'ARRANGE_COLLECTION_START_LOADER';
const ARRANGE_COLLECTION_STOP_LOADER = 'ARRANGE_COLLECTION_STOP_LOADER';

const SET_FIELD_FOR_TRADE_CUSTOMER_1 = 'SET_FIELD_FOR_TRADE_CUSTOMER_1';
const SET_FIELD_FOR_TRADE_CUSTOMER_2 = 'SET_FIELD_FOR_TRADE_CUSTOMER_2';

const BOOK_COLLECTION_FOR_TRADE_1 = 'BOOK_COLLECTION_FOR_TRADE_1';
const BOOK_COLLECTION_FOR_TRADE_1_SUCCESS = 'BOOK_COLLECTION_FOR_TRADE_1_SUCCESS';

const BOOK_COLLECTION_FOR_TRADE_2 = 'BOOK_COLLECTION_FOR_TRADE_2';
const BOOK_COLLECTION_FOR_TRADE_2_SUCCESS = 'BOOK_COLLECTION_FOR_TRADE_2_SUCCESS';

const VALIDATE_PHONE_NUMBER = 'VALIDATE_PHONE_NUMBER';
const VALIDATE_PHONE_NUMBER_FAILED = 'VALIDATE_PHONE_NUMBER_FAILED';

const RESET_ERROR = 'RESET_ERROR';

const SET_IS_BUTTON_PRESSED = 'SET_IS_BUTTON_PRESSED';

export {
  ARRANGE_COLLECTION_REQUEST,
  ARRANGE_COLLECTION_SET_STATUS,

  ARRANGE_COLLECTION_START_LOADER,
  ARRANGE_COLLECTION_STOP_LOADER,

  SET_FIELD_FOR_TRADE_CUSTOMER_1,
  SET_FIELD_FOR_TRADE_CUSTOMER_2,

  BOOK_COLLECTION_FOR_TRADE_1,
  BOOK_COLLECTION_FOR_TRADE_1_SUCCESS,

  BOOK_COLLECTION_FOR_TRADE_2,
  BOOK_COLLECTION_FOR_TRADE_2_SUCCESS,

  VALIDATE_PHONE_NUMBER,
  VALIDATE_PHONE_NUMBER_FAILED,

  RESET_ERROR,

  SET_IS_BUTTON_PRESSED,
};
